import Layout from "../Layout";

export default function ReportErrorPage() {
    return (
        <Layout>
            <div className="container">
                <div className="margin-top row">
                    <div className="hidden-sm col-md-4">
                        <img src="images/pose.png" alt="Gecko Posing" />
                    </div>
                    <div className="col-sm-12 col-md-8">
                        <div className="alert">
                            <div className="alert--high-importance">
                                <span className="icon-alert" />
                                <ul className="alert-list">
                                    <li className="alert-content">
                                        <div className="h4">Page Unavailable</div>
                                        <p>
                                            This page is not available at this time due to technical issues.
                                            We apologize for the inconvenience.
                                            Please try again later or contact the help desk at 1-800-624-2513.
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}